import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryIcon } from 'lucide-react';

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

import { useConsignmentHistory } from '../model';
import { ConsignmentIdDisplay } from './consignment-id-display';
import { HistoryFilters } from './history-filters';
import { HistoryList } from './history-list';

interface ConsignmentHistoryModalProps {
  consignmentId: string;
  trigger?: React.ReactNode;
}

export function ConsignmentHistoryModal({ consignmentId, trigger }: ConsignmentHistoryModalProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const { filters, updateFilter, data, isLoading, hasFilter } = useConsignmentHistory(consignmentId, open);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" size="sm">
            <HistoryIcon className="mr-2 h-4 w-4" />
            {t('newcmr.showhistory.button')}
          </Button>
        )}
      </DialogTrigger>

      <DialogContent className="max-w-4xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader className="pb-4 border-b">
          <DialogTitle className="text-xl font-semibold">{t('newcmr.history.title.message')}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 flex-1 overflow-hidden flex flex-col">
          <ConsignmentIdDisplay consignmentId={consignmentId} />

          <HistoryFilters filters={filters} onFilterChange={updateFilter} />

          <div className="flex-1 overflow-y-auto">
            <HistoryList historyData={data} isLoading={isLoading} hasFilter={hasFilter} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
